export const ponsRewardNftABI = [
    {
      "inputs": [], "name": "SOCIAL_REWARD_POLICY_HASH",
      "outputs": [{ "name": "", "type": "bytes32" }],
      "stateMutability": "view", "type": "function"
    },
    {
      "inputs": [{ "name": "tokenId", "type": "uint256" }],
      "name": "rewardDenominatorFor",
      "outputs": [{ "name": "", "type": "uint256" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "LEGACY_REWARD_POLICY_HASH",
      "outputs": [{ "name": "", "type": "bytes32" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [{ "name": "tierUsd", "type": "uint256" }],
      "name": "mintFeeWeiForTier",
      "outputs": [{ "name": "", "type": "uint256" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "deadline",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "currentTime",
          "type": "uint256"
        }
      ],
      "name": "AuthorizationExpired",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "issuedAt",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "currentTime",
          "type": "uint256"
        }
      ],
      "name": "AuthorizationNotYetValid",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "caller",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        }
      ],
      "name": "AuthorizationWalletMismatch",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "storedWord",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "suppliedWord",
          "type": "uint256"
        }
      ],
      "name": "ConflictingRandomness",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "requestKey",
          "type": "bytes32"
        },
        {
          "internalType": "uint256",
          "name": "existingTokenId",
          "type": "uint256"
        }
      ],
      "name": "DuplicateRandomnessRequest",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "sender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "ERC721IncorrectOwner",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "ERC721InsufficientApproval",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "approver",
          "type": "address"
        }
      ],
      "name": "ERC721InvalidApprover",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        }
      ],
      "name": "ERC721InvalidOperator",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "ERC721InvalidOwner",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "receiver",
          "type": "address"
        }
      ],
      "name": "ERC721InvalidReceiver",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "ERC721InvalidSender",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "ERC721NonexistentToken",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EtherTransferFailed",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "suppliedWei",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "requiredWei",
          "type": "uint256"
        }
      ],
      "name": "IncorrectMintFee",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "availableWei",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "requestedWei",
          "type": "uint256"
        }
      ],
      "name": "InsufficientMintFeeTreasury",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "supplied",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "expected",
          "type": "bytes32"
        }
      ],
      "name": "InvalidAuthorizationInstance",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidAuthorizationSignature",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "bandIndex",
          "type": "uint8"
        }
      ],
      "name": "InvalidBandIndex",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "ticket",
          "type": "uint256"
        }
      ],
      "name": "InvalidBandTicket",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidFeeReceiver",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidInitialization",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "selectedTierUsd",
          "type": "uint256"
        }
      ],
      "name": "InvalidPolicyConfiguration",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "configuredConsumer",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "expectedConsumer",
          "type": "address"
        }
      ],
      "name": "InvalidRandomnessAdapterBinding",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "providerNamespace",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "requestId",
          "type": "bytes32"
        }
      ],
      "name": "InvalidRandomnessIdentity",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint16",
          "name": "rewardBps",
          "type": "uint16"
        }
      ],
      "name": "InvalidRewardBps",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "suppliedVersion",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "suppliedHash",
          "type": "bytes32"
        }
      ],
      "name": "InvalidRewardPolicy",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "enum PonsRewardNft.RewardStatus",
          "name": "currentStatus",
          "type": "uint8"
        }
      ],
      "name": "InvalidRewardStatus",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "modulus",
          "type": "uint256"
        }
      ],
      "name": "InvalidSampleModulus",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "selectedTierUsd",
          "type": "uint256"
        }
      ],
      "name": "InvalidTier",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "selectedTierUsd",
          "type": "uint256"
        }
      ],
      "name": "InvalidTier",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "configuredController",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "expectedController",
          "type": "address"
        }
      ],
      "name": "InvalidVaultController",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NotInitializing",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "payoutWei",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "minimumWei",
          "type": "uint256"
        }
      ],
      "name": "PayoutBelowMinimum",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PayoutIsZero",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "proofKey",
          "type": "bytes32"
        }
      ],
      "name": "ProofAlreadyConsumed",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "requestBlock",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "currentBlock",
          "type": "uint256"
        }
      ],
      "name": "RandomnessFulfilledTooEarly",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "RandomnessProviderUnavailable",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ReentrancyGuardReentrantCall",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ReferralAlreadyClaimed",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "selectedTierUsd",
          "type": "uint256"
        },
        {
          "internalType": "uint16",
          "name": "rewardBps",
          "type": "uint16"
        },
        {
          "internalType": "uint16",
          "name": "minimumBps",
          "type": "uint16"
        },
        {
          "internalType": "uint16",
          "name": "maximumBps",
          "type": "uint16"
        }
      ],
      "name": "RewardBpsOutsideTierRange",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "RewardNotFinalized",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "computedHash",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "expectedHash",
          "type": "bytes32"
        }
      ],
      "name": "RewardPolicyHashInvariant",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "quotedWei",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "requiredWei",
          "type": "uint256"
        }
      ],
      "name": "StaleQuotedMintFee",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TaskMintAlreadyClaimed",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TaskMintCapReached",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TooManyFeeCollections",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "caller",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "expectedAdapter",
          "type": "address"
        }
      ],
      "name": "UnauthorizedRandomnessAdapter",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "caller",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "UnauthorizedRedeemer",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "caller",
          "type": "address"
        }
      ],
      "name": "UnauthorizedTreasury",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "requestKey",
          "type": "bytes32"
        }
      ],
      "name": "UnknownRandomnessRequest",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZeroAddress",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZeroInstanceId",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "approved",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "ApprovalForAll",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "_fromTokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "_toTokenId",
          "type": "uint256"
        }
      ],
      "name": "BatchMetadataUpdate",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "version",
          "type": "uint64"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "_tokenId",
          "type": "uint256"
        }
      ],
      "name": "MetadataUpdate",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "treasury",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amountWei",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "remainingTreasuryWei",
          "type": "uint256"
        }
      ],
      "name": "MintFeesWithdrawn",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "proofKey",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "authorizationId",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "sourceToken",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "selectedTierUsd",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "rewardPolicyVersion",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "rewardPolicyHash",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "mintFeeWei",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "cumulativeTotalMinted",
          "type": "uint256"
        }
      ],
      "name": "PendingNftMinted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "requestKey",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "requestId",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "providerNamespace",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "randomWord",
          "type": "uint256"
        }
      ],
      "name": "RandomnessReady",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "requestKey",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "requestId",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "adapter",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "providerNamespace",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "requestCommitment",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "contextHash",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "requestBlock",
          "type": "uint256"
        }
      ],
      "name": "RandomnessRequested",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "stage",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "nextCounter",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "counterExhausted",
          "type": "bool"
        }
      ],
      "name": "RandomnessSamplingContinued",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "bandIndex",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint16",
          "name": "rewardBps",
          "type": "uint16"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "rewardPolicyHash",
          "type": "bytes32"
        }
      ],
      "name": "RewardFinalized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sourceToken",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint16",
          "name": "rewardBps",
          "type": "uint16"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "poolBeforeWei",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "payoutWei",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "poolAfterWei",
          "type": "uint256"
        }
      ],
      "name": "RewardRedeemed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "AUTHORIZATION_DOMAIN_NAME",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "AUTHORIZATION_DOMAIN_VERSION",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "AUTHORIZATION_SIGNER",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "BASE_MINT_FEE_WEI",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "BPS_DENOMINATOR",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "EIP712_DOMAIN_TYPEHASH",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "FEE_VAULT",
      "outputs": [
        {
          "internalType": "contract IFeeVault",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "INSTANCE_ID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "METADATA",
      "outputs": [
        {
          "internalType": "contract NftMetadataRenderer",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "MINT_AUTHORIZATION_TYPEHASH",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "MINT_AUTHORIZATION_VERSION",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "MINT_FEE_STEP_SIZE",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "MINT_FEE_TREASURY",
      "outputs": [
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "ONCHAIN_RANDOM_NAMESPACE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PAYOUT_ROUNDS_TO_ZERO",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "POOL_EMPTY",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "RANDOMNESS_ADAPTER",
      "outputs": [
        {
          "internalType": "contract IRandomnessAdapter",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "RANDOMNESS_FINAL_CONTEXT_DOMAIN",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "RANDOMNESS_REQUEST_CONTEXT_DOMAIN",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "REDEEMABLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "REWARD_NOT_FINALIZED",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "REWARD_POLICY_HASH",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "REWARD_POLICY_VERSION",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TASK_MINT_CAP",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TASK_REWARD_MAX_BPS",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TASK_REWARD_MIN_BPS",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TASK_TIER_USD",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TEST_FEE_WALLET",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TEST_WALLET_BASE_MINT_FEE_WEI",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TOKEN_NOT_ACTIVE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "proofKey",
          "type": "bytes32"
        }
      ],
      "name": "consumedProof",
      "outputs": [
        {
          "internalType": "bool",
          "name": "consumed",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "cumulativeTotalMinted",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "currentMintFeeWei",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "domainSeparatorV4",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "finalizeReward",
      "outputs": [
        {
          "internalType": "bool",
          "name": "finalized",
          "type": "bool"
        },
        {
          "internalType": "uint8",
          "name": "bandIndex",
          "type": "uint8"
        },
        {
          "internalType": "uint16",
          "name": "rewardBps",
          "type": "uint16"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getApproved",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "instanceId",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "authorizationSigner",
          "type": "address"
        },
        {
          "internalType": "contract IFeeVault",
          "name": "feeVault",
          "type": "address"
        },
        {
          "internalType": "contract IRandomnessAdapter",
          "name": "randomnessAdapter_",
          "type": "address"
        },
        {
          "internalType": "address payable",
          "name": "mintFeeTreasury",
          "type": "address"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        }
      ],
      "name": "isApprovedForAll",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "bytes32",
              "name": "authorizationId",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "instanceId",
              "type": "bytes32"
            },
            {
              "internalType": "address",
              "name": "wallet",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "sourceToken",
              "type": "address"
            },
            {
              "internalType": "bytes32",
              "name": "proofKey",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "challengeCommitment",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "selectedTierUsd",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "rewardPolicyVersion",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "rewardPolicyHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "eligibilitySnapshotHash",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "coverageRevision",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "asOfBlock",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "asOfBlockHash",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "priceTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "quotedMintFeeWei",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "feeStateHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "userContribution",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "issuedAt",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "deadline",
              "type": "uint256"
            }
          ],
          "internalType": "struct PonsRewardNft.MintAuthorization",
          "name": "authorization",
          "type": "tuple"
        },
        {
          "internalType": "bytes",
          "name": "signature",
          "type": "bytes"
        }
      ],
      "name": "mint",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "bytes32",
              "name": "authorizationId",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "instanceId",
              "type": "bytes32"
            },
            {
              "internalType": "address",
              "name": "wallet",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "sourceToken",
              "type": "address"
            },
            {
              "internalType": "bytes32",
              "name": "proofKey",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "challengeCommitment",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "selectedTierUsd",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "rewardPolicyVersion",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "rewardPolicyHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "eligibilitySnapshotHash",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "coverageRevision",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "asOfBlock",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "asOfBlockHash",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "priceTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "quotedMintFeeWei",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "feeStateHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "userContribution",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "issuedAt",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "deadline",
              "type": "uint256"
            }
          ],
          "internalType": "struct PonsRewardNft.MintAuthorization",
          "name": "authorization",
          "type": "tuple"
        }
      ],
      "name": "mintAuthorizationDigest",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "bytes32",
              "name": "authorizationId",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "instanceId",
              "type": "bytes32"
            },
            {
              "internalType": "address",
              "name": "wallet",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "sourceToken",
              "type": "address"
            },
            {
              "internalType": "bytes32",
              "name": "proofKey",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "challengeCommitment",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "selectedTierUsd",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "rewardPolicyVersion",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "rewardPolicyHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "eligibilitySnapshotHash",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "coverageRevision",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "asOfBlock",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "asOfBlockHash",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "priceTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "quotedMintFeeWei",
              "type": "uint256"
            },
            {
              "internalType": "bytes32",
              "name": "feeStateHash",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "userContribution",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "issuedAt",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "deadline",
              "type": "uint256"
            }
          ],
          "internalType": "struct PonsRewardNft.MintAuthorization",
          "name": "authorization",
          "type": "tuple"
        }
      ],
      "name": "mintAuthorizationStructHash",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "mintFeeSurplusWei",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "mintFeeTreasuryWei",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "mintFeeWeiFor",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "nftState",
      "outputs": [
        {
          "internalType": "address",
          "name": "sourceToken",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tierUsd",
          "type": "uint256"
        },
        {
          "internalType": "uint16",
          "name": "rewardBps",
          "type": "uint16"
        },
        {
          "internalType": "uint8",
          "name": "bandIndex",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "status",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "policyVersion",
          "type": "uint256"
        },
        {
          "internalType": "bytes32",
          "name": "policyHash",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "proofKey",
          "type": "bytes32"
        },
        {
          "internalType": "string",
          "name": "sourceTokenName",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "sourceTokenSymbol",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "ownerOf",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "previewRedeem",
      "outputs": [
        {
          "internalType": "address",
          "name": "sourceToken",
          "type": "address"
        },
        {
          "internalType": "uint16",
          "name": "rewardBps",
          "type": "uint16"
        },
        {
          "internalType": "uint256",
          "name": "poolBalanceWei",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "expectedPayoutWei",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "redeemable",
          "type": "bool"
        },
        {
          "internalType": "bytes32",
          "name": "reason",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "randomnessAdapter",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "randomnessRequest",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "requestKey",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "providerNamespace",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "requestId",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "requestCommitment",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "contextHash",
          "type": "bytes32"
        },
        {
          "internalType": "uint256",
          "name": "requestBlock",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "randomWord",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "bandCounter",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "withinBandCounter",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "bandSelected",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "providerNamespace",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "requestId",
          "type": "bytes32"
        },
        {
          "internalType": "uint256",
          "name": "randomWord",
          "type": "uint256"
        }
      ],
      "name": "receiveRandomness",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "minPayoutWei",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "deadline",
          "type": "uint256"
        }
      ],
      "name": "redeem",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "minPayoutWei",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "deadline",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "sweepCurve",
          "type": "bool"
        },
        {
          "internalType": "bytes32[]",
          "name": "collectionIds",
          "type": "bytes32[]"
        }
      ],
      "name": "redeemWithFees",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "selectedTierUsd",
          "type": "uint256"
        },
        {
          "internalType": "uint8",
          "name": "bandIndex",
          "type": "uint8"
        }
      ],
      "name": "rewardBand",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "bandStartBps",
          "type": "uint16"
        },
        {
          "internalType": "uint16",
          "name": "bandEndBps",
          "type": "uint16"
        },
        {
          "internalType": "uint16",
          "name": "weightBps",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardPolicyHash",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardPolicyVersion",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "selectedTierUsd",
          "type": "uint256"
        }
      ],
      "name": "rewardRangeBps",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "minimumBps",
          "type": "uint16"
        },
        {
          "internalType": "uint16",
          "name": "maximumBps",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "rewardStatus",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "rewardWeightsBps",
      "outputs": [
        {
          "internalType": "uint16[5]",
          "name": "",
          "type": "uint16[5]"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "safeTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "setApprovalForAll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "taskMintCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "requestKey",
          "type": "bytes32"
        }
      ],
      "name": "tokenIdByRequestKey",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "tokenURI",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amountWei",
          "type": "uint256"
        }
      ],
      "name": "withdrawMintFees",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ] as const
